import React from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";

interface ButtonProps {
  text: string;
  onClick: () => void;
  className: string;
  viewVariant: string;
}

export const Button: React.FC<ButtonProps> = ({
  text,
  onClick,
  className,
  viewVariant = "primary",
}) => {
  return (
    <div
      onClick={onClick}
      className={classNames(styles.button, className, {
        [styles.primary]: viewVariant === "primary",
        [styles.secondary]: viewVariant === "secondary",
        [styles.third]: viewVariant === "third",
        [styles.crossed]: viewVariant === "crossed",
      })}
    >
      {text}
    </div>
  );
};
